import { mapUrlsIfGhosted } from '@kanda-libs/ks-frontend-services';

export type PageKeys =
  | 'enquiryQuoteComplete'
  | 'enquiryQuoteConfirmDetails'
  | 'enquiryQuoteUploadQuote'
  | 'enquiryQuoteContactDetails'
  | 'enquiryQuoteWelcome'
  | 'enquiryComplete'
  | 'enquiryProjectBudget'
  | 'enquiryWorkDetails'
  | 'enquiryContactDetails'
  | 'enquiryWelcome'
  | 'enquiry'
  | 'home'
  | 'customCode'
  | 'shortUrl'
  | 'staffLogin'
  | 'staff'
  | 'logout';

export const URLS: Record<PageKeys, string> = mapUrlsIfGhosted({
  enquiryQuoteComplete: '/enquiry/quote/complete/:id',
  enquiryQuoteConfirmDetails: '/enquiry/quote/confirm-details/:id',
  enquiryQuoteUploadQuote: '/enquiry/quote/upload-quote/:id',
  enquiryQuoteContactDetails: '/enquiry/quote/contact-details/:id',
  enquiryQuoteWelcome: '/enquiry/quote/:id',
  enquiryComplete: '/enquiry/complete/:id',
  enquiryProjectBudget: '/enquiry/project-budget/:id',
  enquiryWorkDetails: '/enquiry/work-details/:id',
  enquiryContactDetails: '/enquiry/contact-details/:id',
  enquiryWelcome: '/enquiry/welcome/:id',
  enquiry: '/enquiry/:id',
  customCode: '/custom-code',
  staff: '/staff',
  staffLogin: '/staff-login',
  logout: '/logout',
  shortUrl: '/:url',
  home: '/',
});

export const APP_ENV = process.env.REACT_APP_ENV || 'qa';

export const CRYPTO_KEY =
  process.env.REACT_APP_CRYPTO_KEY || 'Y3V5wnShTIqxwlvgDSKKX9b6THaSzVfh';
